module.exports = __webpack_public_path__ + "static/13-a5064b29cdccb0399d4840f0ef06b83f.jpg";